module.exports = __webpack_public_path__ + "static/image5_en-6641464f3f4e106c3624e2384e66a3ff.png";